import React from 'react';
import ReactGiphySearchbox from 'react-giphy-searchbox';

const App = ({width, selectUrl}) => (
  <ReactGiphySearchbox
    apiKey="EskaqjJb9WhTEvP4gKgcu8ZHx0X5CVzh" // Required: get your on https://developers.giphy.com
    onSelect={item => selectUrl(item.id)}
    placeholder="Search Giphy"
    libray='stickers'
		masonryConfig={[
      { columns: 3, imageWidth: width, gutter: 5 },
      /*{ mq: '560px', columns: 4, imageWidth: 110, gutter: 5 },*/
    ]}
    gifListHeight={400}
  />
)

export default App;